import getURLParams from 'utils/DOM/getURLParams'
import { getTodayDate, stringToDate, getDifferenceOnDays } from '@hc-frontend/utils'

function getContextDates() {
  const today = getTodayDate()
  const firstNovemberDate = `11/01/${today.getFullYear()}`
  const firstNovember = stringToDate(firstNovemberDate)
  const isTodayFirstNovember = today.getTime() === firstNovember.getTime()
  const URLParams = getURLParams()
  const quoteDate = isTodayFirstNovember ? firstNovemberDate : URLParams['quote-date']
  const hasQuoteDate = !!quoteDate
  const thirtyFirstAugustDate = `08/31/2024`
  const thirtyFirstAugust = stringToDate(thirtyFirstAugustDate)

  return { today, quoteDate, hasQuoteDate, thirtyFirstAugust }
}

function getLastStartDate() {
  const { today, hasQuoteDate, thirtyFirstAugust } = getContextDates()

  // It is necessary to restrict the plans that Pivot will show to the user before and after the 31st of August 2024
  // This is related to the new law that will be in effect from that date
  if (today < thirtyFirstAugust) {
    const daysUntilThirtyFirstAugust = getDifferenceOnDays(today, thirtyFirstAugust)
    if (daysUntilThirtyFirstAugust <= 60) return daysUntilThirtyFirstAugust - 1
  }

  return hasQuoteDate ? 61 : 60
}

function getQuoteDate() {
  const { quoteDate } = getContextDates()

  return quoteDate
}

export { getLastStartDate, getQuoteDate }
